module.exports = {
  "country": "UK",
  "artist": "The Shadows",
  "song": "Let Me Be the One",
  "year": "1975",
  "place": "2",
  "spotify": "6gZvvkOUTl33NDsbi3lzKr"
};